import { FC, useMemo, useEffect, useState } from 'react';
import { EuropeSites } from '../../util';
import styled from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import { useReferralStore } from '@/components/ReferralHalloween/ReferralProvider';
import EcoImg from 'eco-design/base/eco-img';

interface BannerProps {
    subtitle?: string;
    title: string;
    desc: string;
    children: JSX.Element[] | JSX.Element | boolean;
    isInner?: boolean;
}

const Banner: FC<BannerProps> = ({ subtitle, title, desc, children, isInner = true }) => {
    const { isMobile, useRouter } = useGlobal();
    const { locale, pathname } = useRouter();
    const { pageUsing, actStatus } = useReferralStore();
    const [isUseBg, setIsUseBg] = useState(false);

    useEffect(() => {
        const whitelist = ['/referral', '/referral-rewards'];
        const limitedSites = ['us', 'ca'];

        if (whitelist.includes(pathname) && limitedSites.includes(locale) && actStatus === 1) {
            setIsUseBg(true);
        } else {
            setIsUseBg(false);
        }
    }, [actStatus]);

    return (
        <div id="referral-banner" className={`${styled.banner}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1760342109526/kv.jpg"
                // pad="https://websiteoss.ecoflow.com/upload/image/1760339016735/kv-pad.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1760339016735/kv-pad.jpg"
            />
            <div className="banner_text">
                {isInner && (
                    <div className={`content ${isUseBg ? 'blue_bg' : ''}`}>
                        {subtitle && <p className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></p>}
                        <h1 className="title" dangerouslySetInnerHTML={{ __html: title }}></h1>
                        <p className="desc" dangerouslySetInnerHTML={{ __html: desc }}></p>
                        <div className="tools">{children && children}</div>
                    </div>
                )}
                {!isInner && (
                    <div className={`content ${isUseBg ? 'blue_bg' : ''}`}>
                        {subtitle && <p className="subtitle">{subtitle}</p>}
                        <h1 className="title">{title}</h1>
                        <p className="desc">{desc}</p>
                        <div className="tools">{children && children}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Banner;
